import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 180px;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 1.5rem;

	> div {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 1.5rem;
		align-items: flex-start;
		justify-content: flex-start;
	}

	@media (max-width: 850px) {
		grid-template-columns: 1fr;
	}
`;

export const inputsDate = styled.div`
	width: 100%;
	display: flex;
	gap: 1rem;
	align-items: center;
	justify-content: center;

	@media (max-width: 800px) {
		flex-direction: column;
	}
`;
